import React, { CSSProperties } from 'react'

import './SquareContainer.scss'

function getInsetStyle(insetPercent?: number): CSSProperties | undefined {
  const amount = Math.floor(insetPercent ?? 0)

  if (!amount) {
    return
  }

  const inset = `${amount}%`

  return {
    boxSizing: 'border-box',
    padding: inset,
  }
}

const SquareContainer: React.FC<{
  size: string
  maxSize?: string
  children: React.ReactChild
  offsetLeft?: string
  offsetTop?: string
  onClick?: () => void
  insetPercent?: number
}> = ({ size, maxSize, children, offsetLeft, offsetTop, onClick, insetPercent }) => {
  return (
    <div
      className="SquareContainer"
      style={{
        width: size,
        maxWidth: maxSize,
        marginLeft: offsetLeft,
        marginTop: offsetTop,
      }}
      onClick={onClick}
    >
      {/* css magic makes this square */}
      <div
        className="child-container"
        style={getInsetStyle(insetPercent)}
      >
        {children}
      </div>
    </div>
  )
}

export default SquareContainer
